import React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Button, Modal } from "react-bootstrap";

class SuccessModal extends React.Component {
  close() {
    this.props.closeModal();
  }

  render() {
    return (
      <div className="modal-bg show">
        <Modal show={true} onHide={() => this.close()} backdrop={"static"}>
          <Modal.Header closeButton>
            <Modal.Title>{this.props.title}</Modal.Title>
          </Modal.Header>

          <Modal.Body>{this.props.content}</Modal.Body>

          <Modal.Footer>
            <Button variant="info" onClick={() => this.close()}>
              <FormattedMessage id="Ok" />
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessModal);
